import axios from "axios";
import { AxiosRequestConfig } from "axios";

axios.defaults.baseURL = process.env.VUE_APP_SERVICES;

// Intercept the request to make sure the token is injected into the header.
if (window.localStorage) {
	axios.interceptors.request.use((config) => {
		if (window.localStorage.getItem("token")) {
			config.headers.Authorization =
				"BEARER " + window.localStorage.getItem("token");

			// testing for IE10 or 11 to add a random string to help with a known IE cache bug
			// https://forum.vuejs.org/t/vue-js-in-ie-11-reactivity-issue-array-doesnt-update/10177
			if (/Trident\/|MSIE/.test(window.navigator.userAgent)) {
				config.params = {
					rand: new Date().getTime()
				};
			}
		}
		return config;
	});
}

// graphSourceValid checks to see if the source is valid. If it has not had its
// ids substituted, then it is not valid (ie. "/listings/{ListingID}/abc" is not
// valid)
export function graphSourceValid(source = null) {
	if (!source) return false;
	return !source.includes("ID}");
}

export function fetchGraphData(source = null) {
	if (!source) return undefined;

	const opts: AxiosRequestConfig = {
		method: "post",
		url: source,
		withCredentials: true
	};
	return axios(opts).then((response) => {
		if (response.status >= 400) {
			throw response;
		}
		if (!response.data) {
			return undefined;
		}
		return response.data;
	});
}

export function fetchApexData(source = null) {
	if (!source) return undefined;

	const opts: AxiosRequestConfig = {
		method: "get",
		url: source
	};
	return axios(opts).then((response) => {
		if (response.status >= 400) {
			throw response;
		}
		if (!response.data) {
			return undefined;
		}
		return response.data;
	});
}

export function exportDownloadableContent(source, method) {
	const opts: AxiosRequestConfig = {
		method: method || "get",
		url: `${source}`,
		withCredentials: true
	};

	return axios(opts).then((response) => {
		if (response.status >= 400) {
			throw response;
		}
		if (!response.data) {
			return undefined;
		}
		return response.data;
	});
}

export function dashboards(method, data) {
	const opts: AxiosRequestConfig = {
		method: method || "get",
		url: `/dashboards`,
		data: data || {},
		withCredentials: true
	};

	if (data && data.id) {
		opts.url = opts.url + "/" + data.id;
	}

	return axios(opts).then((response) => {
		if (response.status >= 400) {
			throw response;
		}
		if (!response.data) {
			return undefined;
		}
		return response.data;
	});
}

export function userDashboards(method, data) {
	const opts: AxiosRequestConfig = {
		method: method || "get",
		url: `/dashboards`,
		data: data || {},
		withCredentials: true
	};

	if (data && data.id) {
		opts.url = opts.url + "/" + data.id;
	}

	return axios(opts).then((response) => {
		if (response.status >= 400) {
			throw response;
		}
		if (!response.data) {
			return undefined;
		}
		return response.data;
	});
}

export function facilitySearch(query, limit) {
	const opts: AxiosRequestConfig = {
		method: "get",
		url: `/listings/search/${query}/${limit || 20}`,
		withCredentials: true
	};

	return axios(opts).then((response) => {
		if (response.status >= 400) {
			throw response;
		}
		if (!response.data) {
			return undefined;
		}
		return response.data;
	});
}

export function cultureslist() {
	const opts: AxiosRequestConfig = {
		method: "get",
		url: "/cultureslist",
		withCredentials: true
	};

	return axios(opts).then((response) => {
		if (response.status >= 400) {
			throw response;
		}
		if (!response.data) {
			return undefined;
		}
		return response.data;
	});
}

export function religionslist() {
	const opts: AxiosRequestConfig = {
		method: "get",
		url: "/religionslist",
		withCredentials: true
	};

	return axios(opts).then((response) => {
		if (response.status >= 400) {
			throw response;
		}
		if (!response.data) {
			return undefined;
		}
		return response.data;
	});
}

export function languageslist() {
	const opts: AxiosRequestConfig = {
		method: "get",
		url: "/languageslist",
		withCredentials: true
	};

	return axios(opts).then((response) => {
		if (response.status >= 400) {
			throw response;
		}
		if (!response.data) {
			return undefined;
		}
		return response.data;
	});
}
